import { NotOverridableComponentProps } from '../../../../../model/Component'
import { AppBox } from '../AppBox'

export type AppNavProps = NotOverridableComponentProps

export function AppNav(props: AppNavProps) {
  return <AppBox {...props} component={'nav'} />
}
